<template>
  <div></div>
</template>

<script lang="ts">
  import Vue from 'vue';

  type QRRedirectType = 'register' | 'login';

  export default Vue.extend({
    computed: {
      type(): QRRedirectType {
        const queries = this.$router.currentRoute?.query ?? {};
        const type = queries.type as string ?? 'login';
        return type.toLowerCase() as QRRedirectType;
      },
    },
    beforeMount() {
      this.saveQueries();
      this.redirectByType(this.type);
    },
    methods: {
      saveQueries() {
        const { query } = this.$router.currentRoute;
        Object.keys(query).forEach((key) => {
          const value = query[key];
          this.$sessionStorage.set(`qr-${key}`, value);
        });
      },
      redirectByType(type: string) {
        const { query } = this.$router.currentRoute;
        if (type === 'register') {
          this.$router.replace({ path: this.$config.values['auth-redirects-register'], query });
        } else if (type === 'login') {
          this.$router.replace({ path: this.$config.values['auth-redirects-login'], query });
        }
      },
    },
  });
</script>
